import React from "react";
import PropTypes from "prop-types";

import UpContainerLoading from "../up-container-loading";
import LoadingSpinner from "../loading-spinner";
import FancyLoadingIcon from "../fancy-loading-icon";

const FALLBACK_STATES = {
  login: (
    <UpContainerLoading width="100%" flex="auto" padding="0 0 150px">
      <LoadingSpinner borderColor="rgba(255,255,255,0.3)" />
    </UpContainerLoading>
  ),
  dashboard: (
    <UpContainerLoading width="100%" height="calc(100vh - 101px)">
      <FancyLoadingIcon />
    </UpContainerLoading>
  ),
  component: (
    <UpContainerLoading width="100%">
      <LoadingSpinner />
    </UpContainerLoading>
  )
};

interface LoadingFallbackProps {
  path?: string;
}

const isFallbackState = (path: string): path is keyof typeof FALLBACK_STATES =>
  Object.prototype.hasOwnProperty.call(FALLBACK_STATES, path);

const LoadingFallback = ({ path = "component" }: LoadingFallbackProps) => {
  const fallback = isFallbackState(path) ? FALLBACK_STATES[path] : undefined;

  return <>{fallback}</>;
};

LoadingFallback.propTypes = {
  path: PropTypes.string
};

export default LoadingFallback;
